import styled, { createGlobalStyle } from 'styled-components';
import tw from 'twin.macro';
import { mix, transparentize } from 'polished';

export const GlobalStyles = createGlobalStyle`
  html {
    font-family: "Helvetica Neue", -apple-system, BlinkMacSystemFont, Helvetica, sans-serif;
    color: ${(props) => props.theme.color.foreground};
    background-color: ${(props) => mix(0.95, props.theme.color.background, props.theme.color.foreground)};
    ${tw`leading-normal overflow-y-scroll overflow-x-hidden`}
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${(p) => p.theme.color.primary};
  }

  blockquote {
    ${tw`
      text-2xl px-4 py-6 ml-1 mt-6
    `}
    background-color: ${(p) => transparentize(0.95, p.theme.color.foreground)};
    box-shadow: -6px 0 0 ${(p) => p.theme.color.primary};
  }

  p {
    ${tw`
      text-lg leading-relaxed tracking-wide break-normal
    `}
  }

  h1,h2,h3,h4,h5,h6 {
    ${tw`mb-6`}
  }

  p, blockquote, ul, li {
    + h1, + h2, + h3, + h4, + h5, + h6 {
      ${tw`mt-12`}
    }
  }

  li:not(:last-child):not([class]) {
    ${tw`mb-2`}
  }

  h1 {
    ${tw`text-4xl leading-tight font-medium`}
  }

  h2 {
    ${tw`text-3xl leading-tight font-bold`}
  }

  h3 {
    ${tw`text-2xl leading-tight font-bold`}
  }

  ul:not([class]),
  ol:not([class]) {
    ${tw`pl-4 mb-6`}
  }

  ul:not([class]) {
    list-style-type: none;
    li:not([class]) {
      &:before {
        content: "–";
        color: ${(p) => p.theme.color.secondary};
        ${tw`font-bold mr-1`}
      }
    }
  }

  a:not([class]),
  a:not([class]):visited {
    ${tw`opacity-100 hover:opacity-75 focus:opacity-75`}
    color: ${(p) => p.theme.color.primary};
    transition: all 150ms ${(p) => p.theme.easing};
  }

  hr {
    ${tw`
      w-1/3 max-w-full border-none my-6 mx-0
    `}
    border-top: 2px solid ${(p) => p.theme.color.secondary};
  }

  [contenteditable]:focus {
    outline: none;
  }
`;

export const Wrapper = styled.div`
  ${tw`
    w-full container mx-auto relative px-10 sm:px-0
  `}
`;

export const Overlay = styled.div`
  ${tw`
    absolute top-0 left-0 w-full h-full opacity-75
  `}
  background-color: ${(p) => p.theme.color.black};
`;


export const Main = styled.main`
  ${tw`
    flex flex-col items-stretch p-0 sm:pb-12
  `}
  background: ${(p) => p.theme.color.black};
`;
